import { useRouter } from 'next/router';

import { SITE_URL } from '@/lib/constants';

export const useUrl = () => {
  const router = useRouter();

  return `${SITE_URL}${router.pathname}`;
};
